module.exports = __webpack_public_path__ + "static/media/ic-field-presence-where-and-when-you-need-it.dca398b3.svg";